import React from "react";

import {
    Table,
    TableBody,
    TableHead,
    TableCell,
    TableRow,
    TablePagination,
    Grid,
    Typography,
    Checkbox,
} from "@material-ui/core";

import "./filemanager.css";

import ViewIcon from "@material-ui/icons/RemoveRedEye";
import IconButton from "@material-ui/core/IconButton";
import { TablePaginationHelper } from "vrcore-dashboard/dist/utilities";
import { Link } from "react-router-dom";
export class TabDataTable extends React.Component {
    render() {
        const {
            files = false,
            rows,
            page,
            setPage,
            setRows,
            setSelected,
        } = this.props;
        return (
            <Grid item lg={10} md={9} sm={12} style={{ overflowX: "scroll" }}>
                <Table dense>
                    <TableHead>
                        <TableRow key={"pagination"}>
                            <TablePagination
                                colSpan={12}
                                ActionsComponent={TablePaginationHelper}
                                count={files.length || 0}
                                rowsPerPage={rows}
                                page={page}
                                onChangePage={(event, page) => setPage(page)}
                                onChangeRowsPerPage={(event) =>
                                    setRows(event.target.value)
                                }
                                rowsPerPageOptions={[50, 100]}
                            />
                        </TableRow>
                        <TableRow key={"titles"}>
                            <TableHeadCell text="File ID" />
                            <TableHeadCell text="File Name" />
                            <TableHeadCell text="File Size" />
                            <TableHeadCell text="Date Added" />
                            <TableHeadCell text="Type" />
                            <TableHeadCell text="Actions" />
                            <TableHeadCell text="Selected" />
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {files && files.length !== 0 ? (
                            files.map((e, i) => {
                                return (
                                    <TableRow key={i}>
                                        <TableBodyCell text={e.file_id} />
                                        <TableBodyCell text={e.file_name} />
                                        <TableBodyCell text={e.file_size} />
                                        <TableBodyCell
                                            text={
                                                e.date_added ===
                                                "undefined-undefined-"
                                                    ? "N/A"
                                                    : e.date_added
                                            }
                                        />
                                        <TableBodyCell text={e.file_type} />

                                        <TableCell>
                                            <div
                                                style={{
                                                    minWidth: 100,
                                                    display: "flex",
                                                    justifyContent:
                                                        "space-between",
                                                }}
                                            >
                                                {e.file_folder ===
                                                "old_files" ? (
                                                    <Link
                                                        to={`pdf-viewer/files/${e.file_id}`}
                                                    >
                                                        <IconButton
                                                            style={{
                                                                color: "indigo",
                                                                border:
                                                                    "1px solid indigo",
                                                            }}
                                                        >
                                                            <ViewIcon />
                                                        </IconButton>
                                                    </Link>
                                                ) : (
                                                    <Link
                                                        to={`pdf-viewer/file_manager/${e.file_folder}/${e.file_id}`}
                                                    >
                                                        <IconButton
                                                            style={{
                                                                color: "indigo",
                                                                border:
                                                                    "1px solid indigo",
                                                            }}
                                                        >
                                                            <ViewIcon />
                                                        </IconButton>
                                                    </Link>
                                                )}
                                            </div>
                                        </TableCell>
                                        {e.flag === false || typeof e.flag === undefined?
                                        <TableCell>
                                            <div
                                                style={{
                                                    minWidth: 100,
                                                    display: "flex",
                                                    justifyContent:
                                                        "space-around",
                                                }}
                                            >
                                                <Checkbox
                                                    checked={e.selected}
                                                    onChange={(event) => {
                                                        files[i].selected =
                                                            event.target.checked;

                                                        setSelected(files);
                                                    }}
                                                    value="checkedB"
                                                    color="primary"
                                                />
                                            </div>
                                        </TableCell>
                           :"N/A" }
                                    </TableRow>
                                );
                            })
                        ) : (
                            <Typography variant="body2">
                                No Files Found
                            </Typography>
                        )}
                    </TableBody>
                </Table>
            </Grid>
        );
    }
}
const TableHeadCell = (props) => {
    return (
        <TableCell>
            <Typography variant="body2">
                <b>{props.text}</b>
            </Typography>
        </TableCell>
    );
};
const TableBodyCell = (props) => {
    return (
        <TableCell>
            <Typography variant="body2">{props.text}</Typography>
        </TableCell>
    );
};
